<template>
	<div class="page">
		<div class="content">
			<Breadcrumb :pathList="pathList"></Breadcrumb>
			<div class="flex-only" style="margin-top: 30px;">
				<el-image style="width: 356px;height: 200px;border-radius: 13px;" :src="detail.img" :preview-src-list="$getImageList(detail.img)">
				</el-image>
				<div class="right flex-1">
					<div>
						<div class="flex flex-b">
							<div class="name">{{detail.name}}</div>
							<div v-if="detail.is_order==1">
								<div class="status">已报名</div>
							</div>
							<div v-else>
								<!-- <div class="status">{{detail.text}}</div> -->
								<div class="status" v-if="detail.status==1">报名中</div>
								<div class="status status2" v-if="detail.status==2">进行中</div>
								<div class="status status3" v-if="detail.status==3">已结束</div>
							</div>
						</div>
						<div class="flex">
							<div class="flag flex flex-c">{{detail.train_cate_name}}</div>
							<!-- <div class="flag flex flex-c">基础操作</div> -->
						</div>
					</div>
					<!-- <div class="login-btn pointer" v-if="detail.is_order==1">
						<span class="text">已报名</span>
					</div>
					<div class="login-btn pointer" v-if="detail.is_order!=1 && detail.status==1"
						@click="$router.push('/trainingConfirm?id='+uuid)">
						<span class="text">立即报名</span>
					</div>
					<div class="login-btn pointer" v-if="detail.is_order!=1 && detail.status==2">
						<span class="text">进行中</span>
					</div>
					<div class="login-btn pointer" v-if="detail.is_order!=1&&detail.status==3">
						<span class="text">已结束</span>
					</div> -->
					<div class="login-btn pointer" @click="detail.btn==1?$router.push('/trainingConfirm?id='+uuid):''">
						<span class="text">{{detail.text}}</span>
					</div>
				</div>
			</div>
			<div class="flex-only">
				<div>
					<div class="titles">培训介绍</div>
					<el-image style="width: 844px;height: 1144px;" :src="detail.img" :preview-src-list="$getImageList(detail.img)">
					</el-image>
				</div>
				<div class="flex-1" style="margin-left: 20px;">
					<div class="titles">培训详情</div>
					<div class="wbox">
						<div class="flex">
							<img src="../../assets/images/icon/irl.png" style="width: 16px;height: 16px;" />
							<div class="tit">培训时间</div>
						</div>
						<div class="time">{{detail.begin_time}} 至 {{detail.end_time}}</div>
						<div class="flex">
							<img src="../../assets/images/icon/idz.png" style="width: 16px;height: 16px;" />
							<div class="tit">培训地点</div>
						</div>
						<div class="time">{{detail.address}}</div>
						<div class="flex">
							<img src="../../assets/images/icon/time.png" style="width: 16px;height: 16px;" />
							<div class="tit">报名时间</div>
						</div>
						<div class="time">{{detail.sign_begin_time}} 至 {{detail.sign_end_time}}</div>
						<div class="flex">
							<img src="../../assets/images/icon/rs.png" style="width: 16px;height: 16px;" />
							<div class="tit">报名情况</div>
						</div>
						<div class="time flex">
							<div class="borRight flex">剩余：<span>{{detail.num-detail.order_num}}</span> 人</div>
							<div style="padding-left: 10px;">总名额：{{detail.num}}人</div>
						</div>
						<div class="flex">
							<img src="../../assets/images/icon/fee.png" style="width: 16px;height: 16px;" />
							<div class="tit">报名费用</div>
						</div>
						<div class="price flex" v-if="detail.pay_type==1">{{detail.score}}
							<div class="span">积分</div>
						</div>
						<div class="price flex" v-if="detail.pay_type==2">¥{{detail.price}}
						</div>
						<div class="price flex" v-if="detail.pay_type==3">免费
						</div>
						<div class="flex">
							<img src="../../assets/images/icon/dj.png" style="width: 16px;height: 16px;" />
							<div class="tit">最低报名会员等级</div>
						</div>
						<div class="time">{{detail.member?detail.member.name:''}}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="toTop" v-if="showBackToTop" @click="scrollToTop"></div>
		<Footer></Footer>
	</div>
</template>

<script>
	import {
		getTrainDetail
	} from "@/api/train";
	import {
		getMember
	} from "@/api/common";
	import Breadcrumb from '../../components/Breadcrumb.vue'
	import Footer from '../../components/Footer.vue'
	export default {
		data() {
			return {
				pathList: [{
					title: '培训列表',
					path: '/training'
				}, {
					title: '这是一个培训名称',
					path: ''
				}],
				showBackToTop: false,
				uuid: '',
				detail: '',
				memberName: ''
			}
		},
		components: {
			Breadcrumb,
			Footer
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll)
			if (this.$route.query.source == "home") {
				this.pathList[0].title = '首页'
				this.pathList[0].path = '/index'
			}
			this.uuid = this.$route.query.id
			this.getTrainDetail()
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll)
		},
		methods: {
			async getTrainDetail() {
				const {
					data,
					status
				} = await getTrainDetail({
					uuid: this.uuid,
				})
				this.detail = data.result
				this.pathList[1].title = this.detail.name
				this.getMember()
			},
			async getMember() {
				const {
					data,
					status
				} = await getMember({
					uuid: this.detail.member_uuid,
				})
				this.memberName = data.result.name
			},
			handleScroll() {
				// 当滚动到距离底部100px时显示按钮（可根据需求调整）
				const scrollY = window.scrollY
				const visibleHeight = document.documentElement.clientHeight
				const pageHeight = document.documentElement.scrollHeight
				this.showBackToTop = (scrollY + visibleHeight) > (pageHeight + 1000)
			},
			scrollToTop() {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				})
			},
		},
	}
</script>

<style lang="less" scoped>
	.toTop {
		position: fixed;
		right: 190px;
		bottom: 143px;
		background: url('../../assets/images/home/top.png') no-repeat;
		width: 53px;
		height: 53px;
		z-index: 9999;
		background-size: 100% 100%;
		cursor: pointer;
	}

	.page {
		.content {
			padding: 30px 133px 0;

			.right {
				margin-left: 20px;
				height: 200px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.name {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 600;
					font-size: 27px;
					color: #000000;
				}

				.status {
					height: 22px;
					background: #00A73C;
					border-radius: 7px 7px 7px 7px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #FFFFFF;
					line-height: 22px;
					padding: 0 10px;

					&.status2 {
						background: #D7B155;
					}

					&.status3 {
						background: #FC5F5F;
					}
				}

				.flag {
					margin: 10px 0;
					height: 22px;
					padding: 0 10px;
					line-height: 22px;
					margin-right: 10px;
					background: rgba(0, 0, 0, 0.4);
					border-radius: 4px 4px 4px 4px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #FFFFFF;
				}
			}

			.login-btn {
				margin-top: 10px;
				width: 164px;
				height: 50px;
				background: url('../../assets/images/course/btnw164.png') no-repeat;
				background-size: 100% 100%;
				display: flex;
				align-items: center;
				justify-content: center;

				.text {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 600;
					font-size: 16px;
					text-shadow: 2px 2px 3px rgba(0, 167, 60, 0.4), 1px 1px 1px rgba(255, 255, 255, 0.4);
					text-align: center;
					font-style: normal;
					text-transform: none;
					background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
				}
			}

			.wbox {
				background: #FFFFFF;
				box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
				border-radius: 13px 13px 13px 13px;
				padding: 20px;

				img {
					margin-right: 10px;
				}

				.tit {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 16px;
					color: #666666;
				}

				.time {
					margin: 4px 0 16px 23px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 16px;
					color: #333333;

					span {
						font-family: HONOR Sans CN, HONOR Sans CN;
						font-weight: bold;
						font-size: 16px;
						color: #00A73C;
					}
				}

				.borRight {
					padding-right: 10px;
					height: 12px;
					border-right: 1px solid #999;
				}

				.fee {
					margin: 4px 0 16px 23px;
					font-family: DINPro, DINPro;
					font-weight: bold;
					font-size: 18px;
					color: #00A73C;
				}

				.price {
					margin: 4px 0 16px 23px;
					font-family: DINPro, DINPro;
					font-weight: bold;
					font-size: 22px;
					color: #00A73C;

					.span {
						margin-left: 2px;
						font-family: HONOR Sans CN, HONOR Sans CN;
						font-weight: 400;
						font-size: 13px;
						color: #00A73C;
						margin-top: 5px;
					}
				}
			}
		}
	}
</style>